diy.angular.registerDirective('diyfmupload', ['diyl10n', 'diyfmsectionsdata', 'diyfmuploadqueue', 'diyfmtracking',
function(diyl10n, diyfmsectionsdata, diyfmuploadqueue, diyfmtracking) {
    var $ = jQuery;
    var tpl = '\
        <div class="fm-upload-button-section"\
            diyfmdropfiles="dropFilesConfig" >\
            <div class="fm-upload-button-wrap">\
                <button class="fm-upload-button fm-main-button"\
                    ><span class="ui-icon ui-icon-image-upload-white"></span><span>' + diyl10n('filemanager.upload.button') 
                    + '</span></button>\
            </div>\
        </div>\
        <div class="fm-upload-progress" \
            diyfmdropfiles="dropFilesConfig" \
            ng-show="showProgress"\
            diyfmprogress="progressConfig">\
            <div class="fm-upload-label">' + diyl10n('filemanager.upload.uploading') + '</div>\
            <button class="fm-upload-cancel ui-button-borderless ui-button-small"\
                diybutton="{\'icons\':{\'primary\':\'ui-icon-1and1-delete\'}}"\
                ng-click="cancel()"\
                >' + diyl10n('filemanager.upload.cancel') + '</button>\
        </div>'
        ;

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        compile: function(elem, iattr, transclude) {
            return {
                pre: function(scope, elem, iattr) {
                    
                    var uploadQueue = diyfmuploadqueue.get('storageFiles'), progress = 0, inProgress = false;
                    
                    scope.$on('uploadFiles.down', function(event, files){
                        scope.showProgress = true;
                        
                        if (!inProgress) {
                            inProgress = true;
                            uploadQueue.getPromise().then(function() {
                                inProgress = false;
                            }, function(rejectType) {
                                if (rejectType === 'cancel') {
                                    scope.showProgress = false;
                                    progress = 0;
                                }
                                inProgress = false;
                            }, function(newProgress) {
                                progress = newProgress;
                            });
                        }
                    });
                    
                    scope.cancel = function() {
                        uploadQueue.cancel();
                    };
                    
                    scope.progressConfig = {
                        getter: function() {
                            return progress;
                        },
                        runOnce: false,
                        onFinish: function() {
                            scope.showProgress = false;
                        }
                    };
                    
                    var createFileInput = function() {
                        // cleanup
                        $(elem).find('.fm-upload-button-wrap input[type="file"]')
                            .unbind('change').unbind('click').remove();
                        var input = $('<input type="file" multiple />');
                        $(elem).find('.fm-upload-button-wrap').append(input);
                        input.bind('click', function() {
                            diyfmtracking.track('uploadButtonClick');
                        });
                        input.bind('change', function(){
                            if (this.files && this.files.length > 0) {
                                scope.$emit('uploadFiles.up', this.files, undefined, undefined, 'click-upload');
                                createFileInput();
                            }
                        });
                    };
                    
                    createFileInput();
                    
                    scope.dropFilesConfig = {
                        eventName: 'uploadFiles.up',
                        source: 'drag'
                    };
                }
            };
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmupload.js
 ** module id = 975
 ** module chunks = 0
 **/